import { useEffect, useRef, useState } from "react";
import Icon from "../Icon";

type Option = {
  label: string;
  value: string;
};

type CustomSelectProps = {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  border?: boolean;
};

export default function CustomSelect({
  options,
  value,
  onChange,
  placeholder,
  border,
}: CustomSelectProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // close on outside click
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(e.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel =
    options.find((opt) => opt.value === value)?.label || placeholder;

  return (
    <div className="relative w-full lg:h-[46px]" ref={containerRef}>
      <div
        className={`flex cursor-pointer items-center justify-between rounded-lg border border-gray-300 bg-white p-2 transition hover:border-gray-400 lg:h-full lg:rounded-none ${open ? `border-primary-5 hover:border-primary-5` : ``}`}
        onClick={() => setOpen(!open)}
      >
        <span
          className={`text-sm ${value ? "text-gray-800" : "text-gray-400"}`}
        >
          {selectedLabel}
        </span>
        <div className={`transition ${open ? `rotate-180` : ``}`}>
          <Icon iconName="dropdown" />
        </div>
      </div>

      {open && (
        <div className="absolute z-10 mt-2 w-full rounded border border-gray-200 bg-white shadow-lg">
          {options.length > 0 ? (
            options.map((opt) => (
              <div
                key={opt.value}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                className={`cursor-pointer px-4 py-2 text-sm hover:bg-gray-100 ${
                  opt.value === value ? "bg-gray-100 font-semibold" : ""
                }`}
              >
                {opt.label}
              </div>
            ))
          ) : (
            <div className={`px-4 py-2 text-sm`}>No categories</div>
          )}
        </div>
      )}
    </div>
  );
}
